import DataTable from "datatables.net-react";
import { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import ScriptDropdown from '../components/ScriptDropdown';

function Shorttradereportv2() {

  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null); 
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null); 
  const [selectedBrokerId, setSelectedBrokerId] = useState(null); 
  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [Client, setclient] = useState([]);


  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');

  const handleMarketChange = (market) => {
    setSelectedMarket(market); 
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script); 
  };

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId); 
  };
  
  const handleScriptReset = () => {
    setSelectedScript(null); 
  };

  const handleReset = () => {
    
    setSelectedMarket( null );
    setSelectedScript(null);
    setSelectedAdmin(null);
    setSelectedMaster(null);
    setSelectedBrokerId(null);
    setSelectedSubBrokerId(null);
    setSelectedClient(null);

  };


  return (
    <div className="container-fluid">
      <Card className="mt-2">
        <Card.Body>
          <Row>
          <Col sm={3} xs={6}>
              <b style={{ fontSize: 12 }}> TRADE MINUTE</b>
              <input type="number" className="form-control w-80 bg-light form-control-md fss-01 custom-placeholder text-black" 
                defaultValue={15} />
            </Col>
            <Col sm={3} xs={6}>
            <b className="fss-05">SEGMENT</b>
              <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange} onScriptReset={handleScriptReset}/>

            </Col>
            <Col sm={3} xs={6}>
            <b className="fss-05">SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />
            </Col>
            {user.adminType == 'SUPER_ADMIN' ?
              <>
                <Col sm={3} xs={6}>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}  
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' ?
              <>
                <Col sm={3} xs={6}>
                  <b className="fss-05">MASTER</b>                 
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}
                
                  />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' ?
              <>
                <Col sm={3} xs={6}>
                  <b className="fss-05">BROKER</b>
                  <BrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    setSelectedOption={setSelectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId}
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                  
                  />
                </Col>
              </> : ""}

            {/* {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'BROKER' ?
                  <>
                    <Col>
                     <b className="fss-05">SUB BROKER</b>
                      <SubBrokerDropdown
                        selectedAdmin={selectedAdmin}
                        selectedMaster={selectedMaster}
                        selectedBrokerId={selectedBrokerId}
                        setSelectedBrokerId={setSelectedBrokerId} // Pass setter function here
                        // Or any other value for selectedMaster
                        setSelectedSubBrokerId={setSelectedSubBrokerId}
                        setSelectedOption={setSelectedSubBrokerId}
                        setSelectedClientId={setSelectedClient}
                      />
                    </Col>
                  </> : ""} */}

            <Col sm={3} xs={6}>
             <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                setSelectedOption={handleSelectedClientChange} 
              />
            </Col>

            <Col className="mt-4" xl={3}>
              <Button variant="success" size="sm" >
                Find Trade
              </Button>

              <Button variant="danger" size="sm" style={{ width: 100, marginLeft: 10 }} onClick={handleReset}>
                Clear Search
              </Button>

              <Button variant="secondary" size="sm" style={{ marginLeft: 10 }}>
                Export
              </Button>

            </Col>

          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>
          <DataTable className=' striped bordered'>
            <thead>
              <tr>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>CLIENT</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>SYMBOL</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>FIRST TRADE TYPE</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>RATE</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>QTY</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>FIRST TRADE TIME</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>SECOND TRADE TYPE</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>RATE</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>QTY</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>SECOND TRADE TIME</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>TIME DIFFERENCE</th>
                <th className='bg-secondary ' style={{ fontSize: 12 }}>RATE DIFFERENCE</th>


              </tr>
            </thead>
          </DataTable>
        </Card.Body>
      </Card>
    </div>
  )
}
export default Shorttradereportv2